/* PurePrep AJAX Add to Cart — all data-pureprep-atc buttons */
(function() {
  'use strict';

  function openCartDrawer() {
    // Dawn cart drawer open method
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.open) {
      cartDrawer.open();
      return;
    }
    // fallback: dispatch event Dawn listens for
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:open', { bubbles: true })
    );
    // fallback: click the cart icon
    const cartIconBtn = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [aria-controls="CartDrawer"]');
    if (cartIconBtn) cartIconBtn.click();
  }

  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer')
      .then(r => r.json())
      .then(data => {
        if (!data || !data['cart-drawer']) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newInner = doc.querySelector('.drawer__inner');
        const existing = document.querySelector('#CartDrawer .drawer__inner, cart-drawer .drawer__inner');
        if (newInner && existing) {
          existing.innerHTML = newInner.innerHTML;
          existing.scrollTop = 0;
          // re-bind checkout link
          const checkout = existing.querySelector('[name="checkout"]');
          if (checkout && checkout.tagName === 'BUTTON') {
            const a = document.createElement('a');
            a.href = '/checkout';
            a.className = checkout.className;
            a.textContent = checkout.textContent.trim();
            checkout.parentNode.replaceChild(a, checkout);
          }
        }
      })
      .catch(console.error);
  }

  function handleATC(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const qty = parseInt(btn.dataset.qty || '1', 10);
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(r => r.json())
    .then(data => {
      if (data.status && data.status !== 200) {
        btn.textContent = data.description || 'Error';
        setTimeout(() => { btn.disabled = false; btn.textContent = originalText; }, 2000);
        return;
      }
      btn.textContent = '✓ Added!';
      refreshCartDrawer();
      setTimeout(openCartDrawer, 150);
      setTimeout(() => { btn.disabled = false; btn.textContent = originalText; }, 1800);
    })
    .catch(err => {
      console.error('ATC error:', err);
      btn.disabled = false;
      btn.textContent = originalText;
    });
  }

  // Bundle selector logic
  function initBundleSelector() {
    const selectors = document.querySelectorAll('[data-pureprep-bundle-option]');
    if (!selectors.length) return;
    selectors.forEach(function(opt) {
      opt.addEventListener('click', function() {
        selectors.forEach(s => s.classList.remove('pp-bundle-selected'));
        opt.classList.add('pp-bundle-selected');
        // update ATC button variant
        const variantId = opt.dataset.variantId;
        const price = opt.dataset.price;
        const atcBtn = document.querySelector('[data-pureprep-atc][data-bundle-main]');
        if (atcBtn && variantId) atcBtn.dataset.variantId = variantId;
        // update displayed price
        const priceEl = document.querySelector('[data-pureprep-price]');
        if (priceEl && price) priceEl.textContent = '$' + price;
        // update ATC button label
        if (atcBtn && price) {
          const label = opt.dataset.label || '';
          atcBtn.textContent = label ? 'Add ' + label + ' — $' + price : 'Add to Cart — $' + price;
        }
      });
    });
    // Auto-select first option
    if (selectors[0]) selectors[0].click();
  }

  // Sticky ATC scroll behaviour
  function initStickyATC() {
    const stickyBar = document.querySelector('.pp-sticky-atc');
    const mainATC = document.querySelector('.pp-main-atc-sentinel');
    if (!stickyBar || !mainATC) return;
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
      });
    }, { threshold: 0.1 });
    observer.observe(mainATC);
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-pureprep-atc]');
    if (btn) { e.preventDefault(); handleATC(btn); }
  });

  document.addEventListener('DOMContentLoaded', function() {
    initBundleSelector();
    initStickyATC();
  });
})();
